import { styled } from 'libs/ui/styled';

interface Props {
  center?: boolean;
}
export const FormContentStyled = styled('div')<Props>(({ center, theme }) => ({
  maxWidth: 831,
  width: '100%',
  margin: 'auto',
  ...(!center && {
    marginTop: 64,
    [theme.breakpoints.down('mobile')]: {
      marginTop: 32,
    },
  }),
}));
